<template>
    <modal @close="$emit('close')" :wide="true">
        <p class="text-white font-bold text-xl top-font -mt-6" slot="header">Ошибка</p>
        <div class="py-8  text-main-text">
            <div class="flex flex-col text-center w-full justify-center items-center">

                <div class="px-6">
                    <img class="-mt-6 flex w-2/5 mb-6 mx-auto" src="@/assets/SVG/big-cross.svg"
                        alt="check-circle">
                    <h5 class="flex flex-col text-center w-full justify-center items-center text-xl font-normal"
                        v-text="text">
                        Необходимо удалить эту команду<br> из другой игры данной серии</h5>


                </div>
            </div>

        </div>
    </modal>
</template>

<script>
import ModalMixin from '@/mixins/modals.js';
import Modal from '@/views/modals/base-modal-white';

export default {

  components: { Modal },
  props: ['text'],
  mixins: [ModalMixin],
  mounted() {
  },

};

</script>

<style scoped>

</style>
